import { RETRY_CONFIG } from './apiConfig';

const DEFAULT_REFRESH_INTERVAL_MS = 1000 * 60 * 10; // 10 minutes fallback

export const AUTH_CONFIG = {
    TOKEN_REFRESH_INTERVAL: DEFAULT_REFRESH_INTERVAL_MS,
    RETRY: RETRY_CONFIG,
};

/**
 * Update refresh interval from backend response.
 * Backend returns refresh_interval in seconds.
 * Convert to milliseconds for setTimeout.
 */
export const updateRefreshInterval = (refreshIntervalSeconds) => {
    const parsed = Number(refreshIntervalSeconds);
    if (Number.isFinite(parsed) && parsed > 0) {
        AUTH_CONFIG.TOKEN_REFRESH_INTERVAL = parsed * 1000;
    }
};
export const getTokenRefreshInterval = () => ({
    milliseconds: AUTH_CONFIG.TOKEN_REFRESH_INTERVAL,
    seconds: AUTH_CONFIG.TOKEN_REFRESH_INTERVAL / 1000,
    minutes: AUTH_CONFIG.TOKEN_REFRESH_INTERVAL / (1000 * 60),
});

export const PUBLIC_PATHS = ['/login'];